export class FundStatusInteractionsConstants {
	public static readonly ACCEPT_DISMISS_ID = 'acceptDismiss';
	public static readonly DISMISS_ID = 'dismiss';
}
